import React from "react";
import { Navigate } from "react-router-dom";
import { usePermissoes } from "../contexts/PermissoesContext.tsx";
import { TipoUsuario } from "../types/Permissoes.ts";

interface Props {
  children: React.ReactNode;
  /** Funcoes que podem abrir a rota. */
  permitidos: TipoUsuario[];
}

/**
 * Esconde rotas que a funcao do usuario nao alcanca. Irmao de AdminRoute e
 * EnterpriseRoute.
 *
 * Conveniencia de interface, nao seguranca: quem autoriza de fato e o
 * FuncionalidadeInterceptor no backend. Serve para o usuario nao esbarrar numa
 * tela que so lhe daria erro.
 *
 * NAO usar em /meu-plano nem em /planos/listagem sem pensar duas vezes: o
 * ProtectedRoute manda todo mundo para /meu-plano quando o plano vence, e
 * bloquear o destino desse redirecionamento criaria um ping-pong de rotas.
 */
const RoleRoute: React.FC<Props> = ({ children, permitidos }) => {
  const { tipo, isLoading, erroAoCarregar } = usePermissoes();

  // Enquanto carrega nao da para decidir: redirecionar aqui jogaria o usuario
  // para fora de uma rota que ele tem direito de ver.
  if (isLoading) return null;

  // Nao deu para confirmar a funcao: deixa passar. Quem barra e o servidor, e
  // ele devolve uma mensagem clara. Bloquear aqui, sem saber, expulsaria um
  // administrador legitimo da propria tela por causa de uma falha de rede.
  if (erroAoCarregar) return <>{children}</>;

  if (!tipo || !permitidos.includes(tipo)) {
    return <Navigate to="/cirurgias" replace />;
  }

  return <>{children}</>;
};

export default RoleRoute;
